import Control from "../1. Core/Control";
import IconSelect from "../1. Core/Controls/Select/IconSelect";
import Delegate from "../1. Core/Delegate";
import ListGroupHeader from "../1. Core/Controls/ListBox/ListGroupHeader";
import NP from "../1. Core/NP";
import {getTournaments, ITournament} from "../10. Battle/Util";
import {SportType} from "../10. Battle/types";


export default class FantasyFilterPanel extends Control {

	public EvFilterSortChanged: Delegate;

	private _tournamentCombo: IconSelect;
	//private _eventCombo: IconSelect;

	private _sortFieldCombo: IconSelect;
	private _sortDirectionCombo: IconSelect;

	_initFields(settings: object)
	{
		this.EvFilterSortChanged = new Delegate();
		super._initFields(settings);
	}

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_render()
	{
		this._initComponent('<div class="filter-panel"></div>');

		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'Parameters',
			Class: 'app-list-group__subheader--accent'
		});

		this._tournamentCombo = new IconSelect({
			ParentNode: this._root,
			FloatingLabel: NP.RM.getString('Tournaments'),
			SelectedIndex: 0,
			Items: [{
				Value: null,
				FontImage: NP.FontImages.event,
				Content: NP.RM.getString('AllTournaments')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});


		new ListGroupHeader({
			ParentNode: this._root,
			RK: 'OrderBy',
			Class: 'app-list-group__subheader--accent'
		});

		this._sortFieldCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 2,
			Items: [{
				Value: 'Tournament',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('Tournament')
			}, {
				Value: 'Event',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('Event')
			}, {
				Value: 'EventDate',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('EventDate')
			}, {
				Value: 'Status',
				FontImage: NP.FontImages.sort,
				Content: NP.RM.getString('Status')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._sortDirectionCombo = new IconSelect({
			ParentNode: this._root,
			SelectedIndex: 0,
			Items: [{
				Value: -1,
				FontImage: NP.FontImages.arrow_downward,
				Content: NP.RM.getString('Desc')
			}, {
				Value: 1,
				FontImage: NP.FontImages.arrow_upward,
				Content: NP.RM.getString('Asc')
			}],
			EvItemSelected: () => this._applyFiltersSort()
		});

		this._renderItems([this._root], this._ParentNode || document.documentElement);

		if (NP.isAdmin())
			this.loadFilters();
		else
			this._tournamentCombo.setIsVisible(false);
	}

	private loadFilters()
	{
		getTournaments(SportType.MMA).then((res: ITournament[]) =>
		{
			if (this._tournamentCombo)
			{
				let items = res.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name}));
				this._tournamentCombo.addItems(items);
			}
		});
	}

	_applyFiltersSort()
	{
		this.EvFilterSortChanged.fire(this, this.getFilterData())
	}

	getFilterData()
	{
		return {
			TournamentId: this._tournamentCombo.getValue(),
			SortField: this._sortFieldCombo.getValue(),
			SortDirection: this._sortDirectionCombo.getValue(),
		}
	}

	setSortValues(sortField: string, sortDirection: number)
	{
		this._sortFieldCombo.setValue(sortField, false);
		this._sortDirectionCombo.setValue(sortDirection, false);
	}
}
